/** Activatie van een klikbaar mini-kaartje (klik of Enter/spatie), met het ankerpunt voor het info-paneel. */
export interface HdMiniCardActivation {
  readonly origin: { x: number; y: number };
}

/**
 * Ankerpunt van een kaartje-activatie: de muispositie bij een klik, het midden
 * van het kaartje bij het toetsenbord (een keydown heeft geen coördinaten).
 */
export function resolveHdMiniCardActivation(event: Event, host: HTMLElement): HdMiniCardActivation {
  if (event instanceof MouseEvent && (event.clientX !== 0 || event.clientY !== 0)) {
    return { origin: { x: event.clientX, y: event.clientY } };
  }
  const rect = host.getBoundingClientRect();
  return { origin: { x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 } };
}
